import { createContext, useContext } from "react";
import { IExportCycleContext } from "Views/Bills/V2/PaymentRun/types";

export const ExportCycleContext = createContext<IExportCycleContext>(null);
export const useExportCycleContext = () => useContext(ExportCycleContext);
